import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView, StyleSheet, TextInput } from "react-native";
import { observer } from "mobx-react";
import { extraStore } from "../stores/ExtraStore";
import { navigate } from "../services/NavigationService";
import { PlusIcon, PencilSimpleIcon, TrashIcon, FunnelSimple as FilterIcon, MagnifyingGlass as SearchIcon } from "@phosphor-icons/react";
import { Theme } from "../enum/Theme";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import { Language } from "@constants/language";
import { ModalFiltroLanguage } from "../comps/ModalFiltroLanguage";
import { getFlagByLanguage } from "../services/getFlagByLanguage";
import SpaceW from "@comps/SpaceW";

const Extras = observer(() => {
  const { extras, loading, deleteExtra } = extraStore;

  const [modalVisible, setModalVisible] = useState(false);
  const [filterLang, setFilterLang] = useState<Language | null>(null);
  const [searchText, setSearchText] = useState("");

  const extrasFiltered = extras.filter((extra) => {
    // Filtro por idioma
    const matchesLanguage = !filterLang || extra.lang === filterLang;
    
    // Filtro por busca (título, resumo e descrição)
    const matchesSearch = !searchText || 
      (extra.title && extra.title.toLowerCase().includes(searchText.toLowerCase())) ||
      (extra.resume && extra.resume.toLowerCase().includes(searchText.toLowerCase())) ||
      (extra.description && extra.description.toLowerCase().includes(searchText.toLowerCase()));
    
    return matchesLanguage && matchesSearch;
  });


  if (loading) {
    return <Text style={{ textAlign: "center", marginTop: 50 }}>Carregando extras...</Text>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <TouchableOpacity style={styles.addButton} onPress={() => navigate(EnumRoutesAppWeb.createEditExtra)}>
          <PlusIcon size={20} color="#fff" />
          <Text style={styles.addButtonText}>Novo Extra</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.filterButton} onPress={() => setModalVisible(true)}>
          <FilterIcon size={22} color={Theme.foreground} />
        </TouchableOpacity>
      </View>

      <View style={styles.searchContainer}>
        <View style={styles.searchInputContainer}>
          <SearchIcon size={20} color="#666" style={styles.searchIcon} />
          <TextInput
            style={styles.searchInput}
            placeholder="Buscar por título ou conteúdo..."
            value={searchText}
            onChangeText={setSearchText}
            placeholderTextColor="#999"
          />
        </View>
      </View>

      <ScrollView>
        {extrasFiltered.map((extra) => (
          <View style={styles.row} key={extra.id}>
            <Text style={{ fontSize: 18 }}>{getFlagByLanguage(extra.lang)}</Text>
            <SpaceW />
            <Text numberOfLines={1} ellipsizeMode="tail" style={styles.rowText}>
              {extra.title || "-"}
            </Text>
            <SpaceW />
            <View style={styles.actions}>
              <TouchableOpacity onPress={() => navigate(EnumRoutesAppWeb.createEditExtra, { extra })}>
                <PencilSimpleIcon size={20} color="#555" />
              </TouchableOpacity>
              <SpaceW />
              <TouchableOpacity onPress={() => deleteExtra(extra.id)}>
                <TrashIcon size={20} color="#E57373" />
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </ScrollView>

      <ModalFiltroLanguage
        visible={modalVisible}
        value={filterLang}
        onSelect={setFilterLang}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
});

export default Extras;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  topBar: { flexDirection: "row", alignItems: "center", marginBottom: 15 },
  addButton: {
    backgroundColor: Theme.foreground,
    padding: 10,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  addButtonText: { color: "#fff", marginLeft: 5 },
  filterButton: {
    marginLeft: 10,
    padding: 7,
    borderRadius: 5,
    backgroundColor: "#e6e6e6",
  },
  searchContainer: { marginBottom: 15 },
  searchInputContainer: { 
    flexDirection: "row", 
    alignItems: "center", 
    backgroundColor: "#fff", 
    borderRadius: 8, 
    paddingHorizontal: 12, 
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: "#ddd"
  },
  searchIcon: { marginRight: 8 },
  searchInput: { 
    flex: 1, 
    fontSize: 16, 
    color: "#333",
    paddingVertical: 4
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },
  rowText: { flex: 2 },
  actions: { flexDirection: "row", gap: 10 },
});
